import { IDBAttachment, IAttachment, ETables, IAPIAttachment } from '@ab-task/types';
import { normalize, ID2GUID, GUID2ID } from './core';

export function attachmentDB2JS(dbAttachment: IDBAttachment): IAttachment {
    return {
        messageId: normalize(dbAttachment.att_message_id),
        filename: dbAttachment.att_filename,
        contentType: dbAttachment.att_content_type,
        s3Key: dbAttachment.att_s3_key,
        createdAt: dbAttachment.att_created_at,
    };
}

export function attachmentDB2API(dbAttachment: IDBAttachment): IAPIAttachment {
    return {
        __typename: 'Attachment',
        messageId: ID2GUID(ETables.messages, dbAttachment.att_message_id),
        filename: dbAttachment.att_filename,
        contentType: dbAttachment.att_content_type,
        s3Key: dbAttachment.att_s3_key,
        createdAt: dbAttachment.att_created_at.toISOString(),
    };
}

export function attachmentAPI2JS(apiAttachment: IAPIAttachment): IAttachment {
    return {
        messageId: GUID2ID(apiAttachment.messageId)[1],
        filename: apiAttachment.filename,
        contentType: apiAttachment.contentType,
        s3Key: apiAttachment.s3Key,
        createdAt: new Date(apiAttachment.createdAt),
        progress: normalize(apiAttachment.progress),
    };
}
